import api from '@/api';

const state = {
  isAuthenticated: false,
  loading: false,
  error: null
};

const getters = {
  isAuthenticated: state => state.isAuthenticated,
  authError: state => state.error,
  isLoading: state => state.loading
};

const actions = {
  async login({ commit }, { username, password }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);

    try {
      await api.login(username, password);
      commit('SET_AUTHENTICATED', true);
    } catch (error) {
      commit('SET_ERROR', error.message);
      commit('SET_AUTHENTICATED', false);
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async logout({ commit }) {
    try {
      await api.logout();
    } finally {
      commit('SET_AUTHENTICATED', false);
    }
  },

  async verify({ commit }) {
    try {
      const result = await api.verify();
      commit('SET_AUTHENTICATED', result.authenticated);
    } catch (error) {
      commit('SET_AUTHENTICATED', false);
    }
  }
};

const mutations = {
  SET_AUTHENTICATED(state, value) {
    state.isAuthenticated = value;
  },
  SET_LOADING(state, value) {
    state.loading = value;
  },
  SET_ERROR(state, error) {
    state.error = error;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
